import {helperIsComma, helperConverDateJST, arrangePostCodeAddHyphen} from '@/js/util/helper'
import moment from 'moment'

/**
 * APIから取得した商品情報データを,
 * 商品情報入変更モーダルに合うよう整形する
 * @param {object} contract 契約情報
 * @return {object|null} 整形データ
 */

export const editProductInputDataTransformWebApi = (contract) => {
  const d = contract
  if (!d) return null

  const product = d.products.length ? d.products[0] : null

  // 商品情報入変更モーダル データ整理
  const productForm = {
    product: product ? product.store_product_id : null, // 商品情報
    product_other_name: product ? product.product_other_name : null, // 商品情報 その他候補
    service_start_date: d.service_start_date ? helperConverDateJST(d.service_start_date) : null,
    service_end_date: d.service_end_date ? helperConverDateJST(d.service_end_date) : null,
    cash_total: helperIsComma(d.cash_total),
    down_payment: helperIsComma(d.down_money),
    remaining_money: helperIsComma(d.remaining_money),
    finance_category_name: d.finance_category_name,
    payment: d.pay_type,
    split_number: d.split_count ? String(d.split_count) : null,
    bonus_combined_addition_amount: d.bonus_combined_addition_amount,
    bonus_combined_month1: d.bonus_combined_month1,
    bonus_combined_month2: d.bonus_combined_month2,
    bonus_combined_number: d.bonus_combined_number,
    bonus_once_month: d.bonus_once_month ? helperConverDateJST(d.bonus_once_month) : null,
    bonus_twice_month: d.bonus_twice_month ? helperConverDateJST(d.bonus_twice_month) : null,
    payment_period_start: d.payment_period_start ? helperConverDateJST(d.payment_period_start) : null,
    payment_period_end: d.payment_period_end ? helperConverDateJST(d.payment_period_end) : null,
    payment_amount_once: helperIsComma(d.payment_amount_once),
    payment_amount_second: helperIsComma(d.payment_amount_second),
    split_fee: helperIsComma(d.split_fee),
    split_total_payment: helperIsComma(d.split_total_payment),
    total_pay: helperIsComma(d.total_pay),
    person_charge: d.staff_name
  }

  return productForm
}
